import { IconSparkles } from "@tabler/icons-react";
import { PropsWithChildren } from "react";

import { ActionIcon, Button, ButtonProps } from "~/ui";

type AIButtonProps = Omit<ButtonProps, "variant" | "gradient"> & {
  showIcon?: boolean;
  onClick?: () => void;
};
export const AIButton = ({ showIcon = true, ...props }: PropsWithChildren<AIButtonProps>) =>
  props.children ? (
    <Button
      {...props}
      leftIcon={showIcon ? (props.leftIcon ?? <IconSparkles size={20} strokeWidth={1.5} />) : undefined}
      gradient={{ from: "#5198F9", to: "#3d79cb", deg: 35 }}
      variant="gradient"
    >
      {props.children}
    </Button>
  ) : (
    <ActionIcon gradient={{ from: "#5198F9", to: "#3d79cb", deg: 35 }} size={props.size} variant="gradient" onClick={props.onClick}>
      {props.leftIcon ?? <IconSparkles size={20} strokeWidth={1.5} />}
    </ActionIcon>
  );
